{
  "version": 1,
  "asset_id": "fb3d5a8a-9981-47e0-b8a0-9ec5821c26f6",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/fb3d5a8a-9981-47e0-b8a0-9ec5821c26f6/cp503.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/fb3d5a8a-9981-47e0-b8a0-9ec5821c26f6/cp503.jpg",
  "original_filename": "cp503.jpg",
  "size": 112815,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:26Z"
}
